export default "__VITE_ASSET__SlNSiarS__"